module.exports = __webpack_public_path__ + "img/logo_scopos_branco_.0423b7dd.png";